import { useState, useEffect } from 'react'

import type { ReactElement } from 'react'

import defaultSrc from '~/assets/bg-grey.png'

type Props = {
  alt: string
  className?: string
  fallback?: string
  height?: number
  src: string
  width?: number
}

const Image = ({ alt, className, fallback, height = 100, src: initialSrc, width = 100 }: Props): ReactElement => {
  /** Local state */

  const [errored, setErrored] = useState(false)

  const [src, setSrc] = useState(initialSrc)

  /** Effects */

  useEffect(() => {
    setSrc(initialSrc)
    setErrored(false)
  }, [initialSrc, setSrc])

  useEffect(() => {
    if (errored) {
      setSrc(fallback || defaultSrc)
    }
  }, [errored, fallback])

  /** Handlers */

  const handleImgError = () => setErrored(true)

  /** Render */

  return <img alt={alt} className={className} height={height} onError={handleImgError} src={src} width={width} />
}

export default Image
